import { render, staticRenderFns } from "./CreateChannelPartnerAgreementPopUp.vue?vue&type=template&id=b5127386&scoped=true"
import script from "./CreateChannelPartnerAgreementPopUp.vue?vue&type=script&lang=js"
export * from "./CreateChannelPartnerAgreementPopUp.vue?vue&type=script&lang=js"
import style0 from "./CreateChannelPartnerAgreementPopUp.vue?vue&type=style&index=0&id=b5127386&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5127386",
  null
  
)

export default component.exports